import { useState } from "react";

import PropTypes from "prop-types";
import classNames from "classnames";
import {
  ChromePicker,
  SketchPicker,
  SliderPicker,
  TwitterPicker,
} from "react-color";
import styles from "./styles/ColorPicker.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import useClickOutside from "../../../hooks/useClickOutside";

const colorPickerContainerClassName = classNames({
  [styles.colorPickerContainer]: true,
});
const colorDropdownClassName = classNames({
  [styles.colorDropdown]: true,
});

const pickerComponents = {
  TwitterPicker: TwitterPicker,
  SliderPicker: SliderPicker,
  ChromePicker: ChromePicker,
  SketchPicker: SketchPicker,
};

export default function ColorPicker(props) {
  const { picker = "TwitterPicker", type = "" } = props;

  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  function handleClick() {
    if (displayColorPicker) {
      setDisplayColorPicker(false);
    }
  }

  const ref = useClickOutside(handleClick);

  const colorSwatchStyle = {
    backgroundColor: props.color,
  };

  const PickerComponent = pickerComponents[picker];

  return (
    <div ref={ref}>
      <div
        onClick={() => setDisplayColorPicker((v) => !v)}
        className={colorPickerContainerClassName}
      >
        {type} <span>{props.color}</span>
        <div style={colorSwatchStyle} />
        <FontAwesome ariaHidden={true} name="fa-angle-down" prefix={"fas"} />
      </div>
      {displayColorPicker && (
        <div className={colorDropdownClassName}>
          <PickerComponent
            color={props.color}
            onChangeComplete={(color) => props.handleColorChange(color.hex)}
            triangle={"top-right"}
            colors={props.colors}
            disableAlpha={true}
          />
        </div>
      )}
    </div>
  );
}

ColorPicker.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string.isRequired,
  colors: PropTypes.array,
  picker: PropTypes.oneOf([
    "TwitterPicker",
    "SliderPicker",
    "SketchPicker",
    "ChromePicker",
  ]),
  handleColorChange: PropTypes.func.isRequired,
};
